export default {"src":"/_next/static/media/arabic-flag-svg.d0564eb2.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};